import { render } from "./PaymentRedirectModal.vue?vue&type=template&id=3ad48df2&scoped=true"
import script from "./PaymentRedirectModal.vue?vue&type=script&lang=js"
export * from "./PaymentRedirectModal.vue?vue&type=script&lang=js"

import "./PaymentRedirectModal.vue?vue&type=style&index=0&id=3ad48df2&scoped=true&lang=scss"

import exportComponent from "/home/runner/work/dating-app/dating-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ad48df2"]])

export default __exports__